
import api from "../utils/api";

export const getEmails = async (username) => {
    try {
        const response = await api.get(`/get_emails?username=${encodeURIComponent(username)}`);
        return response.data;
    } catch (error) {
        console.error("Get emails error:", error);
        throw error;
    }
};

export const addEmail = async (username, email, branch) => {
    try {
        const response = await api.post("/add_email", {
            username,
            email,
            branch,
        });
        return response.data;
    } catch (error) {
        console.error("Add email error:", error);
        throw error;
    }
};

export const updateEmail = async (username, oldEmail, newEmail) => {
    try {
        const response = await api.post("/update_email", {
            username,
            old_email: oldEmail,
            new_email: newEmail,
        });
        return response.data;
    } catch (error) {
        console.error("Update email error:", error);
        throw error;
    }
};


export const deleteEmail = async (username, email, branch) => {
    try {
        const response = await api.delete(`/delete_email`, {
            params: { username, email, branch }
        });
        return response.data;
    } catch (error) {
        console.error("Delete email error:", error);
        throw error;
    }
};

// ---------------------------------
// Report Windows Management
// ---------------------------------

export const getReportWindows = async (username) => {
    try {
        const response = await api.get(`/get_report_windows?username=${encodeURIComponent(username)}`);
        return response.data;
    } catch (error) {
        console.error("Get report windows error:", error);
        throw error;
    }
};

export const addReportWindow = async (username, start, end) => {
    try {
        const response = await api.post("/add_report_window", {
            start,
            end,
        }, {
            params: { username }
        });
        return response.data;
    } catch (error) {
        console.error("Add report window error:", error);
        throw error;
    }
};

export const deleteReportWindow = async (username, start, end) => {
    try {
        const response = await api.delete("/delete_report_window", {
            data: { start, end },
            params: { username }
        });
        return response.data;
    } catch (error) {
        console.error("Delete report window error:", error);
        throw error;
    }
};

export const editReportWindow = async (username, oldStart, oldEnd, newStart, newEnd) => {
    try {
        const response = await api.put("/edit_report_window", {
            old_start: oldStart,
            old_end: oldEnd,
            new_start: newStart,
            new_end: newEnd
        }, {
            params: { username }
        });
        return response.data;
    } catch (error) {
        console.error("Edit report window error:", error);
        throw error;
    }
};
